import httpClient from './httpClient';

const tramoRentaService = {
  // Obtener todos los tramos de renta
  obtenerTramosRenta: async () => {
    try {
      console.log('🔄 Obteniendo tramos de renta...');
      const response = await httpClient.get('/tramos-renta');
      console.log('✅ Tramos de renta obtenidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener tramos de renta:', error);
      throw error;
    }
  },

  // Obtener un tramo específico
  obtenerTramoRenta: async (id) => {
    try {
      console.log('🔄 Obteniendo tramo de renta:', id);
      const response = await httpClient.get(`/tramos-renta/${id}`);
      console.log('✅ Tramo de renta obtenido:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener tramo de renta:', error);
      throw error;
    }
  },

  // Crear nuevo tramo de renta
  crearTramoRenta: async (tramoData) => {
    try {
      console.log('🔄 Creando tramo de renta:', tramoData);
      const response = await httpClient.post('/tramos-renta', tramoData);
      console.log('✅ Tramo de renta creado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al crear tramo de renta:', error);
      throw error;
    }
  },

  // Actualizar tramo de renta
  actualizarTramoRenta: async (id, tramoData) => {
    try {
      console.log('🔄 Actualizando tramo de renta:', id, tramoData);
      const response = await httpClient.put(`/tramos-renta/${id}`, tramoData);
      console.log('✅ Tramo de renta actualizado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar tramo de renta:', error);
      throw error;
    }
  },

  // Eliminar tramo de renta
  eliminarTramoRenta: async (id) => {
    try {
      console.log('🔄 Eliminando tramo de renta:', id);
      const response = await httpClient.delete(`/tramos-renta/${id}`);
      console.log('✅ Tramo de renta eliminado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al eliminar tramo de renta:', error);
      throw error;
    }
  }
};

export default tramoRentaService; 